import { Tooltip } from 'devextreme-react';
import { Component } from 'react';

class FontAwesomeIcon extends Component {
    static idCounter = 1;

    render() {
        // types: solid regular duotone thin light regular
        let cl = `fa-${this.props.type ?? 'duotone'} ${this.props.icon.startsWith('fa-') ? '' : 'fa-'}${this.props.icon}`;
        let sid = this.props.sid ?? 'faicon-' + FontAwesomeIcon.idCounter++;

        if (Array.isArray(this.props.effects) && this.props.effects?.length > 0)
            this.props.effects.forEach(e => {
                cl += e.startsWith('fa-') ? ` ${e}` : ` fa-${e}`;
            });
        else if (typeof (this.props.effects) === 'string' && this.props.effects?.length > 0) {
            let eff = effects.split(' ');
            eff.forEach(e => {
                cl += e.startsWith('fa-') ? ` ${e}` : ` fa-${e}`;
            });
        }

        cl += (this.props.flip ? ` fa-flip-${this.props.flip}` : ''); // 'vertical' or 'horizontal'
        cl += (this.props.bounce ? ' fa-bounce' : '');
        cl += (this.props.spin ? ' fa-spin' : '');
        cl += (this.props.shake ? ' fa-shake' : '');
        cl += (this.props.beat ? ' fa-beat' : '');
        cl += (this.props.fade ? ' fa-fade' : '');
        cl += (this.props.beatFade ? ' fa-beat-fade' : '');
        cl += (this.props.rotation > 0 ? ` fa-rotate-${this.props.rotation}` : '');

        let hint = this.props.hint ?? this.props.tooltip;
        let hintText = hint?.text ?? hint?.message ?? hint?.content ?? hint ?? '';
        let hintTitle = hint?.title ?? this.props.hintTitle ?? '';

        return (
            <>
                <i id={sid} className={cl} style={{ ...this.props.style, fontSize: this.props.fontSize }}
                    onClick={this.props.onClick ?? (() => { })} onMouseEnter={this.props.onMouseEnter}
                >
                </i>
                {hintText?.length > 0 &&
                    <Tooltip target={`#${sid}`} title={hintTitle ?? ''} showEvent={{ name: 'mouseenter', delay: 1000 }} hideEvent='mouseleave'
                        {...this.props.tooltipProps}
                    >
                        <b>{hintText}</b>
                    </Tooltip>
                }
            </>
        );
    }
}

export default FontAwesomeIcon;